import { JsonObject, JsonProperty } from 'json2typescript';
import { FixedCode } from './fixed-code';

//** Model stanice použitý v jízdním řádu * /
@JsonObject("Station")
export class Station {
  @JsonProperty('id', String)
  id: string = ""
  @JsonProperty('name', String)
  name: string = ""
  @JsonProperty('arrivalTime', String, true)
  arrivalTime: string | undefined = undefined
  @JsonProperty('arrivalDateTime', Date, true)
  arrivalDateTime: Date | undefined = undefined
  @JsonProperty('departureTime', String, true)
  departureTime: string | undefined = undefined
  @JsonProperty('departureDateTime', Date, true)
  departureDateTime: Date | undefined = undefined
  @JsonProperty('platform', String, true)
  platform: string | undefined = undefined
  @JsonProperty('passed', Boolean, true)
  passed: boolean = false
  @JsonProperty('delay', Number, true)
  delay: number | undefined = undefined
  @JsonProperty('zoneExtId', String, true)
  zoneExtId: string | undefined = undefined
  @JsonProperty('zone', Number, true)
  zone: number | undefined = undefined
  @JsonProperty('borderZones', [Number], true)
  borderZones: number[] | undefined = undefined
  @JsonProperty('fixedCodes', [Array<FixedCode>], true)
  fixedCodes: FixedCode[] = [];

  /**
   * Vrátí true, pokud je zastávka na znamení.
   */
  isRequestStation() {
    return this.hasCode("D");
  }

  /**
   * Vrátí true, pokud je stanice bezbariérově přístupná.
   */
  isWheelchairAccessible() {
    return this.hasCode("H");
  }

  /**
   * Vrátí true, pokud má stanice občerstvení.
   */
  hasCatering() {
    return this.hasCode("M");
  }

  /**
   * Vrátí true, pokud je stanice přístupná pro nevidomé.
   */
  isBlindAccessible() {
    return this.hasCode("G");
  }

  /**
   * Vrátí true, pokud vlastnost "fixedCodes" obsahuje zadaný kód.
   * @param code Kód vlastnosti
   */
  private hasCode(code: string): boolean {
    return this.fixedCodes?.some(c => c.fontChar == code)
  }
}
